import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
// import Loader from "../../../../components/loader/loader";
import Loader from "../../../../../components/loader/loader";
// import { admin_event_view } from "../../admin.api";
// import "./view.css";
import jwtDecode from "jwt-decode";
import moment from "moment";
import {
  admin_advertisement_list,
  admin_event_view,
  advertisement_approve_status,
  advertisement_revert_status,
} from "../../../admin.api";
import Swal from "sweetalert2";
export default function View(props) {
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);
  const [data, setData] = useState({});
  const [isActive, setIsActive] = useState([]);
  const [url, setUrl] = useState("");
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const adParams = useParams();
  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const fetchEventDetails = () => {
    setIsActive(true);
    admin_advertisement_list().then((res) => {
      let tdata = res.filter((item) => item.id == adParams.id);
      console.log(res, tdata);
      setData(tdata[0]);
      setIsActive(false);
    });
  };

  useEffect(() => {
    fetchEventDetails();
  }, []);
  const handleDownloadBrochure = (data) => {
    let path = `${result}${data}`;
    window.open(path, "_blank");
  };

  const handleApproveStatus = (status) => {
    let data = { status: status };
    let selectedParam = adParams?.id;
    // this.setState({ isActive: true });
    setIsActive(true);
    console.log(data?.id);
    advertisement_approve_status(selectedParam, data)
      .then((res) => {
        setSnackMessage(res?.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
        props?.history?.push("/advertisement-list");
      })
      .catch((error) => {
        setSnackMessage(error?.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
      });
  };
  const saMessage = (status) => {
    Swal.fire({
      title: "Message",
      input: "textarea",
      inputLabel: "Provide a reason",
      showCancelButton: true,
      confirmButtonColor: "#0A223D",
      confirmButtonText: "Submit",
      cancelButtonText: "Cancel",
      inputAttributes: {
        "aria-label": "Type your message here",
      },
      inputValidator: (value) => {
        if (!value.trim()) {
          return "Please describe the reason";
        }
      },
    }).then((message) => {
      if (message.isConfirmed && message.value.trim()) {
        let rpdetails = data?.id;

        if (!rpdetails) {
          // console.error("Advertisement ID is missing.");
          setSnackMessage("Advertisement Id is missing");
          setIsSnackError(false);
          setSnackOpen(true);
          setIsActive(false);
          return;
        }

        let rdata = {
          status: status,
          rp_id: rpdetails,
          revert_reason: message.value,
        };

        if (adminType === 1) {
          rdata[status === 1 ? "admin_message" : "user_message"] =
            message.value;
        } else {
          rdata["super_admin_message"] = message.value;
        }

        setIsActive(true);

        advertisement_revert_status(rpdetails, rdata)
          .then((res) => {
            setSnackMessage(res?.message);
            setIsSnackError(false);
            setSnackOpen(true);
            props?.history?.push("/advertisement-list");
          })
          .catch((error) => {
            setSnackMessage(error?.message);
            setIsSnackError(false);
            setSnackOpen(true);
          })
          .finally(() => {
            setIsActive(false);
          });
      }
    });
  };
  const handleEdit = () => {};
  console.log(data);
  return (
    <div>
      <Loader open={isActive} />
      <div className="view-container ">
        <h6 className="d-flex align-items-center">
          <button
            style={{
              backgroundColor: "#0a223d",
              color: "#fff",
              border: "solid 1px #0a223d",
            }}
            type="button"
            className="btn btn-warning btn-sm  mr-2"
            onClick={(e) => {
              props.history.push("/advertisement-list");
            }}
          >
            Back
          </button>
          <b>Advertisement Details</b>
        </h6>

        <hr />
        <div className="data ">
          <div className="row d-flex align-items-center">
            <div className="col-3">Title</div>
            <div className="col-1">:</div>
            <div className="col-7">{data?.title}</div>
          </div>
          {data?.event_code && (
            <div className="row d-flex align-items-center">
              <div className="col-3">Advertisement</div>
              <div className="col-1">:</div>
              <div className="col-7">
                <img
                  className="res_photo"
                  src={`${url}/${data?.file}`}
                  alt="event image"
                />
              </div>
            </div>
          )}

          <div className="row  d-flex align-items-center">
            <div className="col-3">Start Date</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {moment(data?.start_date).format("DD-MM-YYYY")}
            </div>
          </div>
          <div className="row  d-flex align-items-center">
            <div className="col-3">End Date</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {moment(data?.end_date).format("DD-MM-YYYY")}
            </div>
          </div>
          <div className="row  d-flex align-items-center">
            <div className="col-3">Fee </div>
            <div className="col-1">:</div>
            <div className="col-7">{data?.fee}</div>
          </div>
          <div className="row  d-flex align-items-center">
            <div className="col-3">Transaction Details </div>
            <div className="col-1">:</div>
            <div className="col-7">{data?.transaction_details}</div>
          </div>
          <div className="row d-flex align-items-center">
            <div className="col-3">Link</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {data?.link ? (
                <a href={data.link} target="_blank" rel="noopener noreferrer">
                  {data.link}
                </a>
              ) : (
                "-"
              )}
            </div>
          </div>
          {data?.revert_reason && (
            <div className="row  d-flex align-items-center">
              <div className="col-3">Revert Reason </div>
              <div className="col-1">:</div>
              <div className="col-7">{data?.revert_reason}</div>
            </div>
          )}

          {adminType === 2 && data?.status === 0 && (
            <div className="d-flex justify-content-center mt-4">
              <button
                type="button"
                className="btn btn-approve btn-success mr-2"
                onClick={() => handleApproveStatus(1)}
              >
                Approve
              </button>
              <br />
              <button
                type="button"
                className="btn btn-reject btn-danger"
                onClick={() => saMessage(5)}
              >
                Revert with Reason
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
